import { render, staticRenderFns } from "./BaseTLTreeViewItem.vue?vue&type=template&id=5dfbeff8&"
import script from "./BaseTLTreeViewItem.vue?vue&type=script&lang=ts&"
export * from "./BaseTLTreeViewItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports